import { useContext, useEffect, useState } from "react";
import { Alert, Button, Card, Col, Container, Form, Image, Navbar, Row } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { FaExternalLinkAlt } from "react-icons/fa";
import { useHistory } from "react-router";
import Post from "../api/Post";
import { CHECK_CODE_VERIFICACION, RESEND_CODE_VERIFICACION } from "../api/Routes";
import { authContext } from "../context/AuthContext";
import logo from '../img/logos/ike-asistencia.svg'

function DobleAutenticacionFactor({t, objetoLogin}){
    const [code, setCode] = useState('')
    const { setAuthData} = useContext(authContext);
    const history = useHistory();
    const [submiting, setSubmiting] = useState(false)
    const [isValidCode, setIsValidCode] = useState(true)
    const [resendingToken, setReserndingToken] = useState(false)
    const [isValidResend, setIsValidResend] = useState('init')

    useEffect(()=>{
        setAuthData(objetoLogin)
        history.replace('/admin')

        // if(objetoLogin.role !== "Admin" && objetoLogin.role !== "AdminDoctor" && objetoLogin.role !== "AdminOperation"){
        //     setAuthData(objetoLogin)
        //     history.replace('/admin') 
        // }        
    },[])

    const resendCode = () =>{
        setReserndingToken(true)
        //console.log('resending code')
        setIsValidResend('init')
        Post({url: `${RESEND_CODE_VERIFICACION}/${objetoLogin.username}`, data: {}, header: false})
        .then(response=>{
            console.log(response)
            setReserndingToken(false)
            if(response.data){
                setIsValidResend('ok')                       
            }else{
                setIsValidResend('error')
            }
            
        })                
        .catch(error=>{
            setIsValidResend('error')
            setReserndingToken(false)          
        })
    }

    const verificandoCode = () =>{
        console.log('verificando code')
        setIsValidResend('init')
        setSubmiting(true)
        setIsValidCode(true)

        Post({url: `${CHECK_CODE_VERIFICACION}/${objetoLogin.username}/${code}`, data: {}, header: false})
        .then(response=>{
            console.log(response)
            setSubmiting(false)
            if(response.data){                
                setAuthData(objetoLogin)
                history.replace('/admin')            
            }else{
                setIsValidCode(false)
            }
            
        })                
        .catch(error=>{
            setSubmiting(false)
            setIsValidCode(false)           
        })
    }

    return(
        <div>

            <Navbar bg="light" expand="sm" className="light-1">
                <Navbar.Text>
                    <Image src={logo} fluid className="w60p"/>
                </Navbar.Text>          
            </Navbar>

            <Container className="p-md-0 my-5">

                <Row>
                    <Col>
                        <h2>Escriba su código de verificación</h2>
                        <label className="d-block">Para acceder a su cuenta es necesario ingresar el código que le hemos enviado a su celular</label>

                        {
                            !isValidCode && 
                            <Alert variant="danger">El código no es correcto</Alert>
                        }
                        {
                            isValidResend==='ok' ?
                            <Alert variant="success">Le hemos enviado el código</Alert> :
                            isValidResend==='error' ?
                            <Alert variant="success">En estos momentos no podemos enviarle el código. Intente más tarde por favor</Alert> :
                            ''
                        }
                        <Row>
                            <Col xs="12" md="6">
                                <div className="d-flex align-items-center">
                                    <div className="flex-grow-1">
                                        <Form.Control 
                                            value={code}
                                            size="sm"
                                            onChange={e=>setCode(e.target.value)}
                                        />
                                    </div>
                                    <div>
                                        <Button variant="link" onClick={resendCode} className="outline-none shadow-none">
                                            {
                                                resendingToken ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> :
                                                'Reenviar código'
                                            }                                            
                                        </Button>
                                    </div>                        
                                </div>

                                <Button variant="primary" onClick={verificandoCode} className="mt-3 outline-none shadow-none">
                                    {
                                        submiting ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> :
                                        'Veficar'
                                    }
                                    
                                </Button>
                            </Col>
                        </Row>

                        <Row className="mt-5">
                            <Col>   
                                <Card className="shadow-1">
                                    <Card.Body>
                                        <h5 className="font-weight-600">
                                            ¿Por que Iké Asistencia requiere doble factor de autenticación (2FA)?
                                        </h5>

                                        <p>
                                            Iké Asistencia reconoce que las contraseñas robadas, reutilizadas y débiles siguen siendo una de las principales causas de violaciones de seguridad. 
                                            2FA agrega una capa adicional de seguridad a su cuenta al solicitarle que ingrese un código de verificación al iniciar sesión. 
                                            Este paso adicional junto con su contraseña reduce el riesgo de que su cuenta sea invadida.
                                        </p>

                                        <a 
                                            href="https://authy.com/blog/everybody-should-2fa/" 
                                            target="blank"
                                            className="text-primary"
                                        >
                                            Descubra por qué todo el mundo debería 2FA <FaExternalLinkAlt className="font-size-08rem mb-1"/>
                                        </a>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>

                        
                    </Col>
                </Row>

                </Container>
        </div>
    )
}

export default withTranslation()(DobleAutenticacionFactor)